/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './department-need.reducer';

export const DepartmentNeedDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const departmentNeedEntity = useAppSelector(state => state.departmentNeed.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="departmentNeedDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.departmentNeed.detail.title">DepartmentNeed</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.departmentNeed.id">Id</Translate>
            </span>
          </dt>
          <dd>{departmentNeedEntity.id}</dd>
          <dt>
            <span id="shiftDate">
              <Translate contentKey="tinyMedicRestApp.departmentNeed.shiftDate">Shift Date</Translate>
            </span>
          </dt>
          <dd>{departmentNeedEntity.shiftDate}</dd>
          <dt>
            <span id="requestEndDate">
              <Translate contentKey="tinyMedicRestApp.departmentNeed.requestEndDate">Request End Date</Translate>
            </span>
          </dt>
          <dd>{departmentNeedEntity.requestEndDate}</dd>
          <dt>
            <span id="overTimeBonus">
              <Translate contentKey="tinyMedicRestApp.departmentNeed.overTimeBonus">Over Time Bonus</Translate>
            </span>
          </dt>
          <dd>{departmentNeedEntity.overTimeBonus}</dd>
          <dt>
            <span id="minskillLevel">
              <Translate contentKey="tinyMedicRestApp.departmentNeed.minskillLevel">Minskill Level</Translate>
            </span>
          </dt>
          <dd>{departmentNeedEntity.minskillLevel}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.departmentNeed.active">Active</Translate>
            </span>
          </dt>
          <dd>{departmentNeedEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.departmentNeed.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{departmentNeedEntity.cursor}</dd>
          <dt>
            <span id="lastUpdate">
              <Translate contentKey="tinyMedicRestApp.departmentNeed.lastUpdate">Last Update</Translate>
            </span>
          </dt>
          <dd>{departmentNeedEntity.lastUpdate}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.departmentNeed.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{departmentNeedEntity.microSec}</dd>
          <dt>
            <span id="timestampEntry">
              <Translate contentKey="tinyMedicRestApp.departmentNeed.timestampEntry">Timestamp Entry</Translate>
            </span>
          </dt>
          <dd>{departmentNeedEntity.timestampEntry}</dd>
          <dt>
            <span id="neededCount">
              <Translate contentKey="tinyMedicRestApp.departmentNeed.neededCount">Needed Count</Translate>
            </span>
          </dt>
          <dd>{departmentNeedEntity.neededCount}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.departmentNeed.shift">Shift</Translate>
          </dt>
          <dd>{departmentNeedEntity.shift ? departmentNeedEntity.shift.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.departmentNeed.department">Department</Translate>
          </dt>
          <dd>{departmentNeedEntity.department ? departmentNeedEntity.department.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.departmentNeed.ward">Ward</Translate>
          </dt>
          <dd>{departmentNeedEntity.ward ? departmentNeedEntity.ward.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.departmentNeed.hospital">Hospital</Translate>
          </dt>
          <dd>{departmentNeedEntity.hospital ? departmentNeedEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/department-need" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/department-need/${departmentNeedEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default DepartmentNeedDetail;
